import { AxiosInstance } from 'axios'

type Empty = Record<string | number | symbol, never>

export type MetabaseQuestionParametersMap = {
  'total_prescriptions--person_physician': Empty

  'total_screened_patients--clinic': Empty
  'total_screened_patients--person_admin_nvs': Empty
  'total_screened_patients--person_physician': Empty
  'total_screened_patients--person_ct': Empty

  'total_scheduled_patients--clinic': Empty
  'total_scheduled_patients--person_admin_nvs': Empty
  'total_scheduled_patients--person_physician': Empty
  'total_scheduled_patients--person_ct': Empty
}

export type MetabaseQuestionSlug = keyof MetabaseQuestionParametersMap

export function metabaseQuestionEndpoints(apiClient: AxiosInstance) {
  return {
    async run<Slug extends MetabaseQuestionSlug>(
      slug: Slug,
      parameters: MetabaseQuestionParametersMap[Slug],
    ): Promise<Record<string, string>> {
      return apiClient.post(`run-metabase-question/${slug}`, {
        parameters,
      })
    },
  }
}
